export default __webpack_public_path__ + "static/media/add.94f70b88.svg";